function pad2(n) {
  return String(n).padStart(2, '0');
}

/** Local date + time, URL-friendly: YYYY-MM-DD_HHmmss */
export function formatUploadJobTimestamp() {
  const d = new Date();
  return `${d.getFullYear()}-${pad2(d.getMonth() + 1)}-${pad2(d.getDate())}_${pad2(d.getHours())}${pad2(d.getMinutes())}${pad2(d.getSeconds())}`;
}

function sanitizeJobSegment(s) {
  if (s == null) return '';
  const t = String(s).trim();
  if (!t) return '';
  return t.replace(/[^\w.-]+/g, '_').replace(/_+/g, '_').replace(/^_|_$/g, '').slice(0, 48);
}

/**
 * Job name for bulk upload APIs: use trimmed user input, or auto-generate.
 * - With practice + location codes: PracticeCode_LocationCode_YYYY-MM-DD_HHmmss
 * - Without (e.g. Check Upload modal): YYYY-MM-DD_HHmmss only
 */
export function resolveUploadJobName(userEnteredJobName, { practiceCode, locationCode } = {}) {
  const trimmed = (userEnteredJobName || '').trim();
  if (trimmed) return trimmed;
  const ts = formatUploadJobTimestamp();
  const p = sanitizeJobSegment(practiceCode);
  const l = sanitizeJobSegment(locationCode);
  if (p && l) return `${p}_${l}_${ts}`;
  if (p) return `${p}_${ts}`;
  if (l) return `${l}_${ts}`;
  return ts;
}
